<template>
  <layout-card-wrap
    v-loading="loading"
    style="margin-top:15px"
    hasHeaderSlot>
    <template slot="title">检验商品
      <el-button
        v-if="editable"
        type="primary"
        style="margin-left: 10px"
        @click="associate">添加</el-button>
    </template>
    <el-form
      ref="ruleForm"
      :validate-on-rule-change="false"
      :rules="rules"
      :model="inspect">
      <el-form-item
        label-width="0"
        prop="inspectReportDetails">
        <el-table
          border
          :data="inspect.inspectReportDetails">
          <el-table-column
            label="商品名称"
            prop="productName">
          </el-table-column>
          <el-table-column
            label="监管类别"
            width="100">
            <template slot-scope="{row}">
              <el-tag v-if="row.legalTest === 0">非法检</el-tag>
              <el-tag
                v-if="row.legalTest === 1"
                type="danger">法检</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            v-if="editable"
            label="商品数量">
            <template slot-scope="{$index}">
              <el-form-item
                label-width="0"
                :prop="'inspectReportDetails.' + $index + '.productCount'"
                :rules="[{required: true, message: '请输入商品数量', trigger: 'blur'}]">
                <el-input-number
                  v-model="inspect.inspectReportDetails[$index].productCount"
                  :precision="0"
                  :controls="false"
                  :min="1"></el-input-number>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            label="商品数量"
            prop="productCount">
          </el-table-column>
          <el-table-column
            label="创建时间"
            width="100">
            <template slot-scope="{row}">
              {{ row.createdTime | dateformat('YYYY-MM-DD') }}
            </template>
          </el-table-column>
          <el-table-column
            label="批次数量"
            width="100">
            <template slot-scope="{row}">
              {{ row.batchs ? row.batchs.length : 0 }}
            </template>
          </el-table-column>
          <el-table-column
            label="批次信息"
            width="140">
            <template slot-scope="{$index, row}">
              <el-button
                :type="(editable || inspect.status === 3) && userPermission.ENT ? 'primary' : 'text'"
                @click="viewBatch($index,row)">{{ (editable || inspect.status === 3) && userPermission.ENT ? '关联批次' : '查看' }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <associate-product-modal
      ref="modal"
      :selected="inspect.inspectReportDetails"
      :option="{tradeType: tradeType, vendorId: vendorId}"
      @update:selection="handleSelectionChange" />

    <associate-product-batch-modal
      ref="batchModal"
      :tradeType="tradeType"
      :vendorId="vendorId"
      @update:selection="handleBatchChange" />
  </layout-card-wrap>
</template>

<script>
import AssociateProductModal from './associate-product-modal.vue'
import AssociateProductBatchModal from './associate-product-batch-modal.vue'
// import clonedeep from 'lodash.clonedeep'
import { mapState } from 'vuex'
export default {
  name: 'AssociateProduct',
  components: { AssociateProductModal, AssociateProductBatchModal },
  props: {
    loading: [Boolean],
    editable: {
      type: Boolean,
      default: true
    },
    tradeType: [Number, String],
    vendorId: [Number, String],
    value: {
      required: true
    }
  },
  data() {
    return {
      rules: {
        inspectReportDetails: [
          { type: 'array', required: true, message: '请选择商品', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    }),
    inspect: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    associate() {
      this.$refs.modal.toggleModal(true)
    },
    viewBatch(index, row) {
      this.$refs.batchModal.fetch(index, row, this.inspect)
    },
    handleSelectionChange(rows) {
      // let inspectReportDetails = clonedeep(this.inspect.inspectReportDetails)
      // rows.forEach(i => {
      //   if (inspectReportDetails.findIndex(s => s.productId === i.productId) === -1) {
      //     i.batchs = []
      //     inspectReportDetails.push(i)
      //   }
      // })
      const list = rows.map(i => {
        const item = this.inspect.inspectReportDetails.find(s => s.productId === i.productId) || {}
        // i.productCount = item.productCount || 1
        i = {
          ...i,
          ...item
        }
        return i
      })
      // this.$set(this.inspect, 'inspectReportDetails', inspectReportDetails)
      this.inspect.inspectReportDetails = list
    },
    handleBatchChange(index, list) {
      this.$set(this.inspect.inspectReportDetails, index, list)
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            resolve(this.inspect.inspectReportDetails.map(i => ({ productId: i.productId, productCount: i.productCount })))
          } else {
            reject(new Error('商品必须选择'))
          }
        })
      })
      // this.$refs.ruleForm.validate(valid => {
      //   if (valid) {
      //     cb && cb(this.data.list.map(i => ({ productId: i.productId, productCount: i.productCount })))
      //   }
      // })
    }
  }
}
</script>
